import React from "react";
import { Button } from "react-bootstrap";

import RoomDetailsModal from "./room_details_modal";

import styles from "./room_title.module.css";

export default function RoomTitle({ room, property = {}, promotions = [],isModalOpen,setIsModalOpen,handleModalToggle }) {
  

  return (
    <>
      <div className={styles.container}>
        <Button variant="link" className={styles.title} onClick={handleModalToggle}>
          <strong>{room.title}</strong>
        </Button>
        {/* {promotion?.name ? <div className={styles.promotion}>{promotion?.name}</div> : <></>} */}
        <div className="d-flex">
          {promotions?.map((prom,index) => (
            <div className={styles.promotion} key={index}>{prom?.name}</div>
          ))}
        </div>
      </div>
      <RoomDetailsModal
        room={room}
        show={isModalOpen}
        onHide={handleModalToggle}
        property={property}
      />
    </>
  );
}
